'use strict'

const siteButtonLayout = require('../components/SiteButton/siteButonLayout')

module.exports = {
    siteButtonLayout
}
